import { z } from "zod";

/**
 * Search-param schema for the `/fraud` route.
 *
 * `userId` opens that user's dossier drawer. `q` is the queue search: it lives
 * in the URL because a searched-for account is usually outside the default
 * page, so a refresh or shared link without it could not reopen the dossier.
 *
 * Both are coerced and `.catch`-guarded for the same reason as
 * `usersSearchSchema`: TanStack Router JSON-parses raw search values, so a
 * numeric id (or a search for one) arrives as a number, and a ZodError thrown
 * here takes down the router's loader pipeline rather than just ignoring a bad
 * query string.
 */
export const fraudSearchSchema = z.object({
  userId: z.coerce.string().optional().catch(undefined),
  q: z.coerce.string().optional().catch(undefined),
});

export type FraudRouteSearch = z.infer<typeof fraudSearchSchema>;
